import React, { ReactNode } from 'react';

import * as S from './styles';

export type SidebarProps = {
  visible: boolean;
  isFull?: boolean;
  scrollable?: boolean;
  onClose: () => void;
  children: ReactNode;
  conclusion?: boolean;
  isMainNavigation?: boolean;
  withoutPaddingHeaderDesktop?: boolean;
};

const Sidebar = ({
  visible,
  onClose,
  isFull,
  scrollable,
  children,
  conclusion,
  isMainNavigation,
  withoutPaddingHeaderDesktop
}: SidebarProps) => {
  return (
    <S.Content>
      <S.Overlay
        data-testid="test-overlay"
        aria-label="overlay"
        visible={visible}
        isFull={isFull}
        onClick={() => onClose()}
        conclusion={conclusion}
        isMainNavigation={isMainNavigation}
      />
      <S.Sidebar
        data-testid="test-sidebar"
        visible={visible}
        isFull={isFull}
        scrollable={scrollable}
        conclusion={conclusion}
        isMainNavigation={isMainNavigation}
        withoutPaddingHeaderDesktop={withoutPaddingHeaderDesktop}
      >
        {children}
      </S.Sidebar>
    </S.Content>
  );
};

export default Sidebar;
